


































































import { Component, Prop, Vue } from "vue-property-decorator";
import { MimeTypes } from "@/data/enums/files";
import { convertObjAb2Json, downloadBlob } from "@/helpers/file";
import { DataModules } from "@/store/modules/data";
import { IFile } from "@/models/files";

@Component
export default class UFileLink extends Vue {
  // Props

  @Prop({ required: true })
  public file!: IFile;

  @Prop({ required: true })
  public onDownload!: (fileId: IFile["id"]) => Promise<BlobPart>;

  @Prop({ default: null })
  public onDelete!: (fileId: IFile["id"]) => Promise<any> | null;

  // Data

  public isProcessing = false;
  public fileRegex = new RegExp(/^(.*)(\.[a-zA-Z]{1,})$/);

  // Computed

  public get fileName() {
    return this.file.original_name.replace(this.fileRegex, "$1");
  }

  public get fileExtension() {
    return this.file.original_name.replace(this.fileRegex, "$2");
  }

  public get fileTypeMap() {
    // Default type map
    const typeMap = {
      icon: "file-alt",
      iconPack: "far",
      instruction: this.$t("_action.click_to_download"),
      preview: false
    };
    // Return type map based on mime_type
    switch (this.file.mime_type) {
      case MimeTypes.IMAGE_BMP:
      case MimeTypes.IMAGE_GIF:
      case MimeTypes.IMAGE_JP2:
      case MimeTypes.IMAGE_JPEG:
      case MimeTypes.IMAGE_JPM:
      case MimeTypes.IMAGE_JPX:
      case MimeTypes.IMAGE_MS_BMP:
      case MimeTypes.IMAGE_PJPEG:
      case MimeTypes.IMAGE_PNG:
      case MimeTypes.IMAGE_SVG_XML:
      case MimeTypes.IMAGE_TIFF:
      case MimeTypes.IMAGE_VND_ADOBE_PHOTOSHOP:
      case MimeTypes.IMAGE_VND_MICROSOFT_ICON:
      case MimeTypes.IMAGE_WEBP:
      case MimeTypes.IMAGE_XMS_BMP:
      case MimeTypes.IMAGE_X_BITMAP:
      case MimeTypes.IMAGE_X_BMP:
      case MimeTypes.IMAGE_X_ICO:
      case MimeTypes.IMAGE_X_ICON:
      case MimeTypes.IMAGE_X_PNG:
      case MimeTypes.IMAGE_X_WINDOWS_BMP:
      case MimeTypes.IMAGE_X_WIN_BITMAP:
      case MimeTypes.IMAGE_X_XBITMAP:
        return {
          ...typeMap,
          icon: "file-image",
          instruction: this.$t("_action.click_to_view_image"),
          preview: true
        };
      case MimeTypes.APPLICATION_PDF:
        return {
          ...typeMap,
          icon: "file-pdf"
        };
      default:
        return typeMap;
    }
  }

  // Methods

  public async onClick(executeFunc: Function) {
    if (this.isProcessing) return;
    try {
      this.isProcessing = true;
      await executeFunc();
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isProcessing = false;
    }
  }

  public async doDownload(forceDownload = false) {
    try {
      // Get pre-existing blob
      let blob: Blob = this.$_.get(this.file, "blob");

      if (!blob) {
        // Get raw file data (BlobPart)
        const data = await this.onDownload(this.file.id);
        // Cast data as new Blob()
        blob = new Blob([data], { type: this.file.mime_type });
        // Save blob in file object (naughty prop mutation)
        this.$set(this.file, "blob", blob);
      }

      // Download or preview file
      return forceDownload || !this.fileTypeMap.preview
        ? await downloadBlob(blob, this.file.original_name)
        : await this.$store.dispatch(
            `data/${DataModules.IMAGES}/openImagePreviewModal`,
            {
              props: {
                imagePath: URL.createObjectURL(blob)
              }
            }
          );
    } catch (error) {
      // Convert ArrayBuffer data to JSON
      convertObjAb2Json(error, "response.data");
      // Re-throw error
      throw error;
    }
  }
}
